<template>
    <section class="project-section">
      <h1 class="title">{{ t("project_title") }}</h1>
      <p class="description">{{ t("project_description") }}</p>
      <div class="social-links">
      <a href="http://github.com/wilgnerschuertz" target="_blank" rel="noopener noreferrer">
        <i class="fa-brands fa-github"></i>
      </a>
    </div>
    </section>
  </template>
  
  <script>
  import i18n from "@/i18n/i18n";
  import { computed } from "vue";
  
  export default {
    setup() {
      const t = (key) => i18n.get(key);
      return { t };
    },
  };
  </script>
  
  <style scoped>
  /* Estilo Principal */
.project-section {
    display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  padding: 0 32px;
  font-family: "Helvetica Nos Micro Regular", sans-serif;
}
  
.title {
    font-size: 2.5rem;
    color: #222;
    margin-bottom: 20px;
    font-family: "Europa Grotesk SH Med", sans-serif;
}

.description {
  font-size: 1.125rem;
  color: #555;
  line-height: 1.8;
}

.social-links {
  display: flex;
  gap: 16px;
  margin-top: 20px;
}

.social-links a {
  font-size: 2rem;
  color: #555;
  opacity: 0.7;
  transition: all 0.3s;
}

.social-links a:hover {
  color: #000;
  transform: scale(1.2);
}

/* Responsividade */
@media (max-width: 768px) {
  .hero-section {
    padding: 16px;
    text-align: center;
  }

  .title {
    font-size: 1.8rem;
  }

  .description {
    font-size: 1rem;
  }

  .social-links {
    justify-content: center;
  }
}
  </style>
  